











import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class Typography extends Vue {
  @Prop({ default: 'p' }) readonly component?: string;
  @Prop({ default: '' }) readonly color?: string;
  @Prop({ default: '' }) readonly fontSize?: string;
  @Prop({ default: '' }) readonly lineHeight?: string;
  @Prop({ default: '' }) readonly fontWeight?: string;
  @Prop({ default: '' }) readonly textAlign?: string;
  @Prop({ default: '' }) readonly margin?: string;

  get style() {
    return `
      ${this.color ? `color: ${this.color}` : ''};
      ${this.fontSize ? `font-size: ${this.fontSize}` : ''};
      ${this.lineHeight ? `line-height: ${this.lineHeight}` : ''};
      ${this.fontWeight ? `font-weight: ${this.fontWeight}` : ''};
      ${this.textAlign ? `text-align: ${this.textAlign}` : ''};
      ${this.margin ? `margin: ${this.margin}` : ''};
    `;
  }

  @Emit('click')
  click() {}
}
